// extracted by mini-css-extract-plugin
export default {"card":"SectionCard_card__ibT2R","content":"SectionCard_content__VZyu5","card-image":"SectionCard_card-image__-waCY","desc":"SectionCard_desc__LOnsC"};